/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Scandinavian_Studies24Inputs */

const en__field_enum_study_scandinavian_studies24 = /** @type {(inputs: _Field_Enum_Study_Scandinavian_Studies24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scandinavian Studies`)
};

const de__field_enum_study_scandinavian_studies24 = /** @type {(inputs: _Field_Enum_Study_Scandinavian_Studies24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skandinavistik`)
};

/**
* | output |
* | --- |
* | "Scandinavian Studies" |
*
* @param {_Field_Enum_Study_Scandinavian_Studies24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_scandinavian_studies24 = /** @type {((inputs?: _Field_Enum_Study_Scandinavian_Studies24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Scandinavian_Studies24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_scandinavian_studies24(inputs)
	return de__field_enum_study_scandinavian_studies24(inputs)
});
export { _field_enum_study_scandinavian_studies24 as "_field_enum_STUDY_SCANDINAVIAN_STUDIES" }